import { render, staticRenderFns } from "./VideoOnDemand.vue?vue&type=template&id=028ad145&scoped=true&"
import script from "./VideoOnDemand.vue?vue&type=script&lang=js&"
export * from "./VideoOnDemand.vue?vue&type=script&lang=js&"
import style0 from "./VideoOnDemand.vue?vue&type=style&index=0&id=028ad145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ad145",
  null
  
)

export default component.exports